// extracted by mini-css-extract-plugin
export default {"contents-container":"TSLgxM7bd_xXtKzw5UMw","info-section":"AU8uqTv0CgY0pmcLbLTl"};